<template>
  <div class="title">{{ title }}</div>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    title: {
      type: String,
      default: ""
    }
  }
})
</script>

<style lang='less' scoped>
.title {
  display: block;
  position: relative;
  padding-left: 11px;
  font-size: 16px;
  color: @textColor;
  font-weight: bold;
  height: 22px;
  line-height: 22px;

  &::before {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    content: "";
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: @primaryColor;
    border-radius: 2px;
  }
}
</style>